import { Fade } from "@/components/Reveal";

const Kicker = () => (
  <Fade className="mb-10 flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink/45">
    <span className="text-accent-dark">—</span>
    <span className="h-px w-10 bg-ink/20" aria-hidden="true" />
    <span>Legale</span>
  </Fade>
);

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-ink/65 md:text-base">{children}</div>
  </section>
);

const PrivacyPolicyPage = () => (
  <div data-testid="privacy-policy-page" className="bg-fog pt-[72px] text-ink">
    <div className="mx-auto max-w-3xl px-6 py-20 lg:py-28">
      <Kicker />
      <Fade>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
          Privacy Policy
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-ink/40">
          Ultimo aggiornamento: settembre 2026
        </p>
        <p className="mt-8 text-sm leading-relaxed text-ink/65 md:text-base">
          Questa informativa descrive come vengono trattati i dati personali raccolti attraverso
          questo sito, in conformità al Regolamento (UE) 2016/679 (GDPR).
        </p>

        <Section title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento è la ditta individuale Mattia Cosimo Saracino, P.IVA
            02601020742, con sede a Mesagne (BR), Italia.
          </p>
          <p>
            Per qualsiasi questione relativa al trattamento dei dati personali puoi scrivere a:{" "}
            <a href="mailto:saracinomat98@gmail.com" className="text-accent-dark underline underline-offset-4">
              saracinomat98@gmail.com
            </a>
          </p>
        </Section>

        <Section title="2. Dati raccolti">
          <p>
            L'unico punto di raccolta dati di questo sito è il form contatti "Raccontami la tua
            azienda", che raccoglie esclusivamente i dati che decidi di inviare volontariamente:
          </p>
          <p>
            nome, cognome, azienda, ruolo, indirizzo email, numero di telefono, numero di
            collaboratori e il contenuto del messaggio.
          </p>
          <p>
            Il sito non raccoglie automaticamente altri dati personali e non utilizza cookie di
            profilazione o strumenti di tracciamento che richiedano consenso.
          </p>
        </Section>

        <Section title="3. Finalità e base giuridica">
          <p>
            I dati inviati tramite il form vengono utilizzati esclusivamente per rispondere alla tua
            richiesta, ricontattarti e gestire l'eventuale confronto o percorso di consulenza da te
            richiesto.
          </p>
          <p>
            La base giuridica del trattamento è l'esecuzione di misure precontrattuali adottate su
            richiesta dell'interessato (art. 6, par. 1, lett. b) GDPR).
          </p>
        </Section>

        <Section title="4. Modalità del trattamento e destinatari">
          <p>
            I dati inviati vengono conservati in un database sicuro e trasmessi via email al
            titolare tramite un servizio di invio email transazionale. Il sito è ospitato su
            infrastruttura fornita dalla piattaforma di hosting (Emergent), che tratta i dati
            tecnici strettamente necessari all'erogazione del servizio.
          </p>
          <p>
            Nessun dato viene venduto, ceduto o comunicato a terzi per finalità proprie.
          </p>
        </Section>

        <Section title="5. Periodo di conservazione">
          <p>
            I dati vengono conservati per il tempo necessario a ricontattarti e gestire la tua
            richiesta.
          </p>
        </Section>

        <Section title="6. Marketing">
          <p>
            I dati forniti tramite il form non vengono utilizzati per l'invio di comunicazioni di
            marketing o newsletter senza un tuo esplicito consenso.
          </p>
        </Section>

        <Section title="7. Servizi esterni raggiungibili dal sito">
          <p>
            Il sito contiene collegamenti a servizi esterni — Business Freedom 360, Amazon,
            Instagram, LinkedIn e WhatsApp — che applicano le proprie informative privacy. Ti
            invitiamo a consultarle sui rispettivi siti.
          </p>
        </Section>

        <Section title="8. I tuoi diritti">
          <p>
            In qualità di interessato puoi esercitare in qualsiasi momento i diritti previsti dagli
            artt. 15-22 del GDPR: accesso, rettifica, cancellazione, limitazione del trattamento,
            opposizione e portabilità dei dati.
          </p>
          <p>
            Per esercitare i tuoi diritti scrivi a{" "}
            <a href="mailto:saracinomat98@gmail.com" className="text-accent-dark underline underline-offset-4">
              saracinomat98@gmail.com
            </a>
            . Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati
            personali (www.garanteprivacy.it).
          </p>
        </Section>
      </Fade>
    </div>
  </div>
);

export default PrivacyPolicyPage;
